import { skipToken } from "@reduxjs/toolkit/query";
import { openapi } from "../../openapi";
import { useAppSelector } from "../app/hooks";
import { DrofusEndringerFilterBar } from "../DrofusEndringer/DrofusEndringerFilterBar";
import { selectDrofusEndringerRoomGroupsApiArg } from "../DrofusEndringer/drofusEndringerSelectors";

export const DrofusChangesPanel: React.FC = () => {
  const apiArg = useAppSelector(selectDrofusEndringerRoomGroupsApiArg);
  // Subscribe to summaries for every room on the floor, independently of event pagination.
  openapi.usePostMultiplacerDrofusInterfaceProjectChangeEventsByRoomQuery(apiArg ?? skipToken);
  return <DrofusEndringerFilterBar fullWidth />;
};
